import { render, staticRenderFns } from "./Adder.vue?vue&type=template&id=0039069d&scoped=true&"
import script from "./Adder.vue?vue&type=script&lang=js&"
export * from "./Adder.vue?vue&type=script&lang=js&"
import style0 from "./Adder.vue?vue&type=style&index=0&id=0039069d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0039069d",
  null
  
)

export default component.exports